import CarotekColors from "@carotek/utils/Colors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Img from "@insite/mobius/Img";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoSections?: GridItemProps;
    QuickLinkGridItem?: GridItemProps;
    ProductsLinkGridItem?: GridItemProps;
    AddressInfoGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    widgetGridContainer: {
        css: css`
            padding: 2rem 0 1rem;
            color: ${getColor("primary.contrast")};
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    background-color: #f1f1f2;
                    padding-top: 1rem;
                `,
                css`
                    background-color: #f1f1f2;
                    padding-top: 1rem;
                `,
                null,
                null,
                null,
            ])}
        `,
    },
    logoGridItem: {
        width: 12,
        css: css`
            width: 100%;
            display: flex;
            justify-content: center;
            padding-bottom: 3px;
            a {
                display: block;
            }
            img {
                width: 100%;
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    background-color: #f1f1f2;
                    padding-top: 1rem;
                `,
                css`
                    background-color: #f1f1f2;
                    padding-top: 1rem;
                `,
                null,
                null,
                null,
            ])}
        `,
    },
    linkList1GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList2GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList3GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    linkList4GridItem: {
        width: [6, 6, 4, 2, 2],
    },
    subscribeGridItem: {
        width: [12, 12, 8, 4, 4],
    },
    socialLinksGridItem: {
        width: 12,
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
        css: css`
            margin-left: 1.9375rem !important;
            margin-right: 1.9375rem !important;
            border-top: 1px solid ${CarotekColors.grey1};
            font-family: OpenSansBold;
            padding-top: 15px;
            text-align: center;
            font-size: 14px;
            font-weight: bold;
            line-height: 18px;

            color: ${getColor("primary.contrast")};
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    background-color: #f1f1f2;
                    padding-left: 1.9375rem !important;
                    padding-right: 1.9375rem !important;
                    margin: 0 !important;
                `,
                css`
                    background-color: #f1f1f2;
                    padding-left: 1.9375rem !important;
                    padding-right: 1.9375rem !important;
                    margin: 0 !important;
                `,
                null,
                null,
                null,
            ])}
        `,
    },
    logoWrapper: {
        css: css`
            width: 100%;
            padding-top: 15px;
            border-top: 1px solid ${CarotekColors.grey1};
        `,
    },
    logoSections: {
        width: [12, 12, 3, 3, 3],
        css: css`
            flex-direction: column;
            padding-left: 40px;

            > [class^="Wrapper"] {
                img {
                    width: 170px;
                    margin-top: 10px;
                }
            }

            > [class^="Wrapper"]:last-child {
                margin-top: 30px;
                img {
                    width: 145px;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    background-color: #f1f1f2;
                    text-align: center;
                    padding-left: 0;
                `,
                css`
                    background-color: #f1f1f2;
                    text-align: center;
                    padding-left: 0;
                `,
                null,
                null,
                null,
            ])}
        `,
    },
    QuickLinkGridItem: {
        width: [6, 6, 3, 3, 3],
        css: css`
            padding-left: 70px;
            .list-wrapper {
                padding: 0;
            }
            .title-wrapper {
                [class^="TypographyStyle"] {
                    text-transform: uppercase;
                    font-family: OpenSansSemiBold;
                    font-size: 16px;
                    font-weight: 500;
                    margin-bottom: 0.2rem;
                    color: ${getColor("primary.contrast")};
                }
            }

            .list-link {
                line-height: 1.5rem;
                [class^="TypographyStyle"] {
                    text-transform: capitalize;
                    font-size: 13px;
                    font-weight: 400;
                    color: ${getColor("text.disabled")};
                    :hover {
                        text-decoration: underline;
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    background-color: #f1f1f2;
                    padding-left: 15px;
                `,
                css`
                    background-color: #f1f1f2;
                    padding-left: 15px;
                `,
                null,
                null,
                null,
            ])}
        `,
    },
    ProductsLinkGridItem: {
        width: [6, 6, 3, 3, 3],
        css: css`
            padding-left: 28px;
            display: flex;
            flex-direction: column;
            .list-wrapper {
                padding: 0;
            }
            .title-wrapper {
                [class^="TypographyStyle"] {
                    text-transform: uppercase;
                    font-family: OpenSansSemiBold;
                    font-size: 16px;
                    font-weight: 500;
                    margin-bottom: 0.2rem;
                    color: ${getColor("primary.contrast")};
                }
            }

            .list-link {
                line-height: 1.6rem;
                [class^="TypographyStyle"] {
                    text-transform: capitalize;
                    font-size: 13px;
                    font-weight: 400;
                    color: ${getColor("text.disabled")};
                    :hover {
                        text-decoration: underline;
                    }
                }
            }
            a[class^="StyledButton-sc"] {
                margin-left: 0;
            }
                
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    background-color: #f1f1f2;
                    padding-left: 15px;
                `,
                css`
                    background-color: #f1f1f2;
                    padding-left: 15px;
                `,
                null,
                null,
                null,
            ])}
        `,
    },
    AddressInfoGridItem: {
        width: [12, 12, 3, 3, 3],
        css: css`
            display: flex;
            flex-direction: column;
            .title-wrapper {
                [class^="TypographyStyle"] {
                    text-transform: uppercase;
                    font-family: OpenSansSemiBold;
                    font-size: 1.5rem;
                    font-weight: 400;
                    margin-bottom: 20px;
                    color: ${getColor("primary.main")};
                }
            }
            p {
                font-size: 14px;
                line-height: 24px;
                font-weight: 700;
                margin-bottom: 10px;
                font-family: OpenSansBold;
                color: ${getColor("primary.contrast")};
            }
            a[class^="StyledButton-sc"] {
                margin-left: 0;
            }

            .contact-num {
                margin-right: 0px;
                margin-bottom: 8px;
                padding-right: 0px;
                border-right: 0 none;
                //vertical-align: top;
                display: block;

                span[class^="TypographyStyle"] {
                    font-weight: bold;
                    font-family: OpenSansBold;
                    font-size: 24px;
                    color: ${getColor("danger")} !important;

                    :hover {
                        text-decoration: underline;
                    }
                }
            }

            .contact-us {
                padding: 8px 5px 7px;
                background-color: ${getColor("danger")};
                vertical-align: top;
                display: inline-block;
                margin-bottom: 15px;
                line-height: 9px;
                span[class^="TypographyStyle"] {
                    font-size: 13px;
                    font-family: OpenSansBold;
                    font-weight: bold;
                    color: ${CarotekColors.white} !important;

                    :hover {
                        text-decoration: underline;
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    background-color: #f1f1f2;
                    padding-left: 15px;
                `,
                css`
                    background-color: #f1f1f2;
                    padding-left: 15px;
                `,
                null,
                null,
                null,
            ])}
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <GridContainer {...styles.widgetGridContainer}>
            <GridItem {...styles.logoGridItem}>
                <StyledWrapper {...styles.logoWrapper}>
                    <Zone zoneName="newsletterlogo" contentId={id} />
                </StyledWrapper>
            </GridItem>

            <GridItem {...styles.logoSections}>
                <Zone zoneName="carotekLogo" contentId={id} />
                <Zone zoneName="countryLogo" contentId={id} />
            </GridItem>
            <GridItem {...styles.QuickLinkGridItem}>
                <Zone zoneName="productLinks" contentId={id} />
            </GridItem>
            <GridItem {...styles.ProductsLinkGridItem}>
                <Zone zoneName="quickLink" contentId={id} />
            </GridItem>
            <GridItem {...styles.AddressInfoGridItem}>
                <Zone zoneName="SocialLinks" contentId={id} />
            </GridItem>
            <GridItem {...styles.richContentGridItem}>
                <Zone zoneName="RichContent" contentId={id} />
            </GridItem>

            {/*             <GridItem {...styles.linkList1GridItem}>
                <Zone zoneName="LinkList1" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList2GridItem}>
                <Zone zoneName="LinkList2" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList3GridItem}>
                <Zone zoneName="LinkList3" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList4GridItem}>
                <Zone zoneName="LinkList4" contentId={id} />
            </GridItem>
            <GridItem {...styles.subscribeGridItem}>
                <Zone zoneName="Subscribe" contentId={id} />
            </GridItem>
            <GridItem {...styles.socialLinksGridItem}>
                <Zone zoneName="SocialLinks" contentId={id} />
            </GridItem>
            <GridItem {...styles.siteMapLinksGridItem}>
                <Zone zoneName="SiteMapLinks" contentId={id} />
            </GridItem>
            <GridItem {...styles.richContentGridItem}>
                <Zone zoneName="RichContent" contentId={id} />
            </GridItem> */}
        </GridContainer>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
